import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api.service';
import { UtilService } from 'src/app/services/util/util.service';

@Component({
  selector: 'app-pp-assign-add',
  templateUrl: './pp-assign-add.component.html',
  styleUrls: ['./pp-assign-add.component.css']
})
export class PpAssignAddComponent implements OnInit {


  user: any;
  load: boolean = false;
  hasil: any = {};
  hsl: any = {};

  no: any = '';

  datax: any = {};

  kategori: any = '';
  groupcode: any = '';
  groupname: any = '';
  surveyor: any = '';
  ppke: any = '';
  date: any = '';
  time: any = '';

  hasilX: any = {};

  constructor(
    public route: Router,
    public api: ApiService,
    public util: UtilService,
    public modalController: ModalController,
    public formBuilder: FormBuilder,
    public activatedRoute: ActivatedRoute
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      if (params && params.no) {
        this.no = params.no;
        console.log('Resultkw1', this.no)
        // this.datax = JSON.parse(params.datax);
        // console.log('Resultkw', this.datax)
      }
    });
   }

  ngOnInit(): void {
  }

  dateSelection(data: any) {
    // console.log('dateSelection',data)
    this.date = data;
  }

  timeSelection(data: any) {
    // console.log('dateSelection',data)
    this.time = data;
  }

  ionViewWillEnter() {
    this.getList();
  }

  update() {
    if (!this.load){
      if(this.time == ''){
        this.util.showToast('Jam Wajib Diisi','danger','bottom');
        return false;
      }
      if(this.date == ''){
        this.util.showToast('Tanggal Wajib Diisi','danger','bottom');
        return false;
      }
      this.load = true;
      let param = {
        pp_date: this.date,
        pp_time: this.time
      }
      this.api.put('backoffice/pp/assign/'+this.no, param)
        .subscribe((data) => {
          this.hasilX = data;
          this.load = false;
          this.util.showToast(this.hasilX.message,'success','bottom');
          // this.getList();
          this.route.navigateByUrl('/tambah-assign-pp')
        }, (error) => {
          this.load = false;
          console.log('error', error);
          this.api.errorCond(error);
        });
    }
  }

  getList() {
    this.load = true;

    this.api.get('backoffice/pp/assign/list/'+this.no)
      .subscribe((data) => {
        this.hasil = data;
          
        this.hsl = this.hasil.data;
        this.load = false;
       
        this.kategori = this.hsl?.category_group;
        this.groupcode = this.hsl?.id;
        this.groupname = this.hsl?.group_name;
        this.surveyor = this.hsl?.surveyor_name;
        this.ppke = this.hsl?.pp_ke;
       
      }, (error) => {
        this.load = false;
        console.log('error', error);
        this.api.errorCond(error);
      });
  }


}
